<template>
	<v-footer
		id="footer"
		:class="$vuetify.breakpoint.mdAndUp ? 'pt-8 pb-3': 'pt-4 pb-2'"
		color="white"
	>
		<v-container>
			<div
				class="d-md-block d-flex justify-center"
				:class="$vuetify.breakpoint.mdAndUp ? 'mb-10' : 'mb-8'"
			>
				<router-link :to="{ name: 'home' }" class="rounded">
					<v-img
						:src="require('@/assets/logo.png')"
						width="250"
					/>
				</router-link>
			</div>

			<v-row dense align="center">
				<v-col
					md="auto"
					sm="12"
					cols="12"
					class="d-flex flex-wrap align-center justify-center-sm-start justify-center text-sm-start text-center"
				>
					<!-- <div class="font-weight-bold mb-sm-4 mb-1">{{$t('footer.links.about-us')}}</div> -->
					<router-link
						:to="{ name: 'about-us' }"
						class="d-block text-decoration-none grey--text text--darken-2"
					>
						<!-- about-us -->
						{{$t('footer.links.about-forsa')}}
					</router-link>
					<v-divider vertical class="mx-2"/>

					<router-link
						:to="{ name: 'privacy-policy' }"
						class="d-block text-decoration-none grey--text text--darken-2"
					>
						<!-- privacyPolicy -->
						{{$t('footer.links.privacy-policy')}}
					</router-link>
					<v-divider vertical class="mx-2"/>

					<router-link
						:to="{ name: 'terms-and-conditions' }"
						class="d-block text-decoration-none grey--text text--darken-2"
					>
						<!-- qualityPolicy -->
						{{$t('footer.links.terms-conditions')}}
					</router-link>
				</v-col>

				<!-- Contact Details -->
				<v-col
					md="auto"
					sm="12"
					cols="12"
					class=" d-flex flex-wrap align-center justify-center-sm-start justify-center text-sm-start text-center ms-md-16 ms-0"
				>
					<div class="font-weight-bold me-2">{{$t('footer.links.contact-us')}}:</div>
					<a
						href="mailto:Support@forsabarter.com"
						class="d-block text-decoration-none grey--text text--darken-2"
					>
						Support@forsabarter.com
					</a>
					<v-divider vertical class="mx-2"/>
					<a
						dir="auto"
						href="tel:+96520125621"
						class="d-block text-decoration-none grey--text text--darken-2"
						:class="{'text-end': locale === 'ar'}"
					>
						+965 669 582 153
					</a>
				</v-col>
			</v-row>

			<div class="d-flex flex-md-row flex-column justify-space-between align-md-end align-center mt-sm-8 mt-10">
				<div class="d-flex align-center mb-md-0 mb-5">
					<a
						href="https://web.facebook.com/profile.php?id=61552266736142"
						target="_blank"
						class="footer-icon me-8"
					>
						<svg><use xlink:href="@/assets/icons/brands-icons.svg#icon-facebook"/></svg>
					</a>
					<a
						href="https://twitter.com/forsabarter"
						target="_blank"
						class="footer-icon me-8"
					>
						<svg><use xlink:href="@/assets/icons/brands-icons.svg#icon-x"/></svg>
					</a>
					<a
						href="https://www.instagram.com/forsa.barter/"
						target="_blank"
						class="footer-icon me-8"
					>
						<svg><use xlink:href="@/assets/icons/brands-icons.svg#icon-instagram"/></svg>
					</a>
					<a
						href="https://business.tiktok.com/"
						target="_blank"
						class="footer-icon me-8"
					>
						<svg><use xlink:href="@/assets/icons/brands-icons.svg#icon-tiktok"/></svg>
					</a>
					<a
						href="https://www.snapchat.com/add/forsabartr"
						target="_blank"
						class="footer-icon me-8"
					>
						<svg><use xlink:href="@/assets/icons/brands-icons.svg#icon-snapchat"/></svg>
					</a>
					<svg v-if="false" class="footer-icon">
						<use xlink:href="@/assets/icons/brands-icons.svg#icon-linkedin2"/>
					</svg>
				</div>
				<div>
					<a :href="IOS_APP_LINK" target="_blank">
						<img width="180" class="image-download me-1" src="@/assets/apple-store.png">
					</a>
					<a :href="ANDROID_APP_LINK" target="_blank">
						<img width="180" class="image-download" src="@/assets/google-play.png">
					</a>
				</div>
			</div>

			<v-divider class="dark-divider my-sm-4 my-2"/>

			<div class="d-flex flex-sm-row flex-column justify-space-between align-center text-caption">
				<span>{{$t('footer.copyrights', { year: new Date().toISOString().slice(0, 4) })}}</span>
				<div>
					Made with <v-icon size="14" color="primary">mdi-heart</v-icon> By
					<span class="font-weight-black">SOLINICS</span>
				</div>
			</div>
		</v-container>
	</v-footer>
</template>

<script>
import { ANDROID_APP_LINK, IOS_APP_LINK } from '@/helpers/constants';

export default {
	name: 'Footer',
	
	data() {
		return {
			ANDROID_APP_LINK,
			IOS_APP_LINK,
		}
	},

	computed: {
		
	}
}
</script>

<style lang="scss">
#footer {
	.footer-icon {
		color: grey;
		svg {
			width: 21px;
			height: 21px;
		}
	}
}
</style>
